/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  MdFlight,
  MdBadge,
  MdDirectionsBoat,
  MdHotel,
  MdSecurity,
  MdTrain,
  MdBeachAccess,
  MdLocalTaxi,
  MdPayment,
  MdSupportAgent,
  MdTravelExplore,
  MdAssignmentTurnedIn,
  MdGroups,
  MdManageAccounts,
} from 'react-icons/md';
import {
  FaLinkedin,
  FaWhatsapp,
  FaInstagram,
  FaFacebook,
} from 'react-icons/fa';
import './LoginPageVaya.scss';
import { NAVIGATION_ROUTES } from '../../shared/constants/Constants';
import { useAppContext } from '../../saas/AppConfigWrapper';
import { getStringFromLS } from '../../shared/helper-utils/localStorage';
import { APP_LOGO_URL } from '../../saas/AppStorageStaticNames';
import LoginVaya from './LoginVaya';
import BrushStroke from './BrushStroke';

const SERVICES = [
  { Icon: MdFlight, label: 'Flights' },
  { Icon: MdBadge, label: 'Visa' },
  { Icon: MdDirectionsBoat, label: 'Cruises' },
  { Icon: MdHotel, label: 'Hotels' },
  { Icon: MdSecurity, label: 'Insurance' },
  { Icon: MdTrain, label: 'Train' },
  { Icon: MdBeachAccess, label: 'Holidays' },
  { Icon: MdLocalTaxi, label: 'Cabs' },
];

const WHAT_WE_DO = [
  {
    img: '/images/others/vaya_flight_service.jpg',
    title: 'Flight Bookings',
    desc: 'Seamlessly book domestic and international flights at the best fares, simplifying travel arrangements for every kind of traveler with 24/7 support.',
    bullets: [
      'Best Domestic & International Fares',
      'Displayed Prices Include All Taxes',
      '24/7 Flight Booking Support',
      'Infant & Group Booking Assistance',
    ],
  },
  {
    img: '/images/others/vaya_hotel_service.jpg',
    title: 'Hotel Bookings',
    desc: 'Access a wide selection of hotels worldwide, carefully chosen keeping your comfort in mind — guaranteeing delightful stays at highly competitive prices.',
    bullets: [
      'Worldwide Hotel Reservations',
      'Primary Guest Must Be 18+',
      'Valid ID Required at Check-In',
      'Check-In & Check-Out: 12 PM',
    ],
  },
  {
    img: '/images/others/vaya_bus_service.jpg',
    title: 'Bus Booking',
    desc: 'Vayaonline Bus Booking provides valid tickets, refund support and cancellation assistance — all managed through a single, hassle-free platform.',
    bullets: [
      'Valid Ticket Issuance',
      'Cancellation & Refund Support',
      'Customer Support & Information',
      'Inter & Intra City Connectivity',
    ],
  },
  {
    img: '/images/others/vaya_car_service.jpg',
    title: 'Car Rental',
    desc: 'Book your cab with ease — booking voucher sent directly to your email with all details confirmed in advance.',
    bullets: [
      'Booking Voucher on Email',
      'Valid ID Proof Mandatory',
      'Transparent Extra Charges (Toll, Parking, Night Charges)',
      'Refunds Within 7 Business Days',
    ],
  },
  {
    img: '/images/others/vaya_visa_service.jpg',
    title: 'Visa Services',
    desc: 'Expert visa assistance for all major destinations — Tourist, Business & Student visas handled with complete guidance.',
    bullets: [
      'All Major Destinations Covered',
      'Tourist, Business & Student Visa',
      'Expert Guidance Throughout',
      '24x7 Visa Support Available',
    ],
  },
  {
    img: '/images/others/vaya_holiday_service.jpg',
    title: 'Holiday Packages',
    desc: 'Customized domestic and international holiday packages crafted for every type of traveler — from leisure to adventure.',
    bullets: [
      'Personalized & Customized Packages',
      'Leisure, Honeymoon, Adventure & Pilgrimage Tours',
      'Third-Party Supplier Network',
      'Written Confirmation Required',
    ],
  },
  {
    img: '/images/others/vaya_cruise_service.jpg',
    title: 'Cruises',
    desc: "Make every cruise booking a first-class experience with Vayaonline, renowned for designing remarkable getaways on the world's most beautiful waterways.",
    bullets: [
      'Luxury Cruise Experiences',
      'Domestic & International Routes',
      'Group Cruise Packages',
      'Best Value Cruise Deals',
    ],
  },
  {
    img: '/images/others/vaya_insurance_service.jpg',
    title: 'Travel Insurance',
    desc: 'Safeguard your journey with comprehensive travel insurance options that offer protection against unexpected events and ensure complete peace of mind throughout your trip.',
    bullets: [
      'Comprehensive Coverage for Every Trip',
      'Domestic & International Plans',
      'Quick & Efficient Claim Process',
      'Worry-Free Travel Guaranteed',
    ],
  },
];

const BENEFITS = [
  {
    Icon: MdPayment,
    title: 'Secure Payments',
    desc: 'Hassle-free and secure payments processed through trusted payment gateways via Net Banking / UPI / Credit Card',
  },
  {
    Icon: MdSupportAgent,
    title: '24/7 Customer Support',
    desc: 'Get round-the-clock assistance for Holiday Packages and Visa queries — we are always available when you need us',
  },
  {
    Icon: MdTravelExplore,
    title: 'Complete Travel Solutions',
    desc: 'One platform for flights, hotels, visa, insurance, cruises, car rentals and holiday packages — everything under one roof',
  },
  {
    Icon: MdAssignmentTurnedIn,
    title: 'Easy Amendments & Cancellations',
    desc: 'Manage all your bookings smoothly — from reservations to cancellations — with full refund and rescheduling support',
  },
  {
    Icon: MdGroups,
    title: 'Trusted & Experienced Team',
    desc: 'Years of expertise with knowledge, experience and trust as our primary tools — backed by hundreds of satisfied customers',
  },
  {
    Icon: MdManageAccounts,
    title: 'Personalized & Customized Service',
    desc: 'Tailored travel solutions for individuals, families, corporates and groups — your journey planned exactly the way you want it',
  },
];

function LoginPageVaya() {
  const { appConfig } = useAppContext();
  const navigate = useNavigate();

  return (
    <div className="va-page">
      <nav className="va-nav">
        <button
          className="va-logo-btn"
          type="button"
          onClick={() => navigate('/')}
        >
          {getStringFromLS(APP_LOGO_URL) ? (
            <img
              src={getStringFromLS(APP_LOGO_URL)}
              alt={appConfig.companyName}
              style={{ maxHeight: `${appConfig.logoHeight || 44}px` }}
            />
          ) : (
            <span className="va-logo-text">{appConfig.companyName}</span>
          )}
        </button>

        <div className="va-nav-actions">
          {appConfig.helpline24 && (
            <a
              href={`tel:${appConfig.supportNumber}`}
              className="va-nav-phone hide-in-mobile"
            >
              📞 {appConfig.supportNumber}
            </a>
          )}
          <button
            type="button"
            className="va-nav-btn va-nav-btn--outline"
            onClick={() => navigate('/contact-us')}
          >
            Support
          </button>
          <button
            type="button"
            className="va-nav-btn va-nav-btn--solid"
            onClick={() => navigate(NAVIGATION_ROUTES.AGENT_REGISTRATION)}
          >
            Register Agency
          </button>
        </div>
      </nav>

      <section className="va-hero">
        <div className="va-hero-inner">
          <div className="va-hero-left">
            <p className="va-hero-eyebrow">
              We Plan The Journey, You Create The Memories
            </p>
            <h1 className="va-hero-title">
              Reliable Travel <BrushStroke>Solutions</BrushStroke>, Every
              <br />
              Step Of The Way
            </h1>
            <p className="va-hero-subtitle">Excellence In Travel, Every Time</p>
            <div className="va-hero-services">
              {SERVICES.map(({ Icon, label }) => (
                <div className="va-hero-svc" key={label}>
                  <div className="va-hero-svc-icon">
                    <Icon size={32} />
                  </div>
                  <span>{label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="va-hero-right">
            <div className="va-login-card">
              <LoginVaya />
            </div>
          </div>
        </div>
      </section>

      <section className="va-worldmap">
        <img
          src="/images/others/hero_vaya_banner.png"
          alt="hero banner"
          className="va-worldmap-img"
        />
      </section>

      {/* ── OUR SERVICES ── */}
      <section className="va-services">
        <div className="va-services-header">
          <p className="va-services-eyebrow">What We Do</p>
          <h2 className="va-services-title">
            Our <BrushStroke>Services</BrushStroke>
          </h2>
        </div>
        <div className="va-services-list">
          {WHAT_WE_DO.map(({ img, title, desc, bullets }) => (
            <div className="va-svc-card" key={title}>
              <div className="va-svc-card-img">
                <img src={img} alt={title} className="va-svc-card-photo" />
              </div>
              <div className="va-svc-card-body">
                <h3 className="va-svc-card-title">{title}</h3>
                <p className="va-svc-card-desc">{desc}</p>
                <ul className="va-svc-card-list">
                  {bullets.map((b) => (
                    <li key={b}>{b}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="va-about">
        <div className="va-about-inner">
          <div className="va-about-left">
            <p className="va-about-eyebrow">About {appConfig.companyName}</p>
            <h2 className="va-about-title">
              <BrushStroke>{appConfig.companyName}</BrushStroke> is your gateway
              to smarter, more memorable travel experiences
            </h2>
            <p className="va-about-desc">
              {appConfig.companyName} is your trusted travel partner in
              delivering complete end-to-end travel solutions, designed for
              every kind of traveler — individuals, families, corporates, and
              groups.
            </p>
            <p className="va-about-desc">
              {appConfig.companyName} is the ultimate travel solution platform
              where travelers can find all the tools and services they need for
              a perfect journey. Being one of the most trusted travel agencies
              in India, we ease your travel planning by providing customized
              holiday packages to fit every requirement and budget. This
              platform is built to make your travel experience seamless,
              offering flexible itineraries, competitive pricing, and expert
              guidance — making it the best travel partner for all your needs.
            </p>
            <p className="va-about-desc">
              With years of experience and hundreds of satisfied customers, we
              offer industry-leading services and a comprehensive range of
              booking options including flights, hotels, buses, car rentals,
              cruises, and visa assistance.
            </p>
          </div>

          <div className="va-about-right hide-in-mobile">
            <div className="va-about-blob" />
            <img
              className="va-about-photo va-about-photo--1"
              src="../images/others/vaya_b1.jpg"
              alt="Travel destination"
            />
            <img
              className="va-about-photo va-about-photo--2"
              src="../images/others/vaya_b2.jpg"
              alt="Travel destination"
            />
          </div>
        </div>
      </section>

      {/* ── BENEFITS ── */}
      <section className="va-benefits">
        <div className="va-benefits-header">
          <h2 className="va-benefits-title">
            Benefits of <BrushStroke>{appConfig.companyName}</BrushStroke>
          </h2>
        </div>
        <div className="va-benefits-grid">
          {BENEFITS.map(({ Icon, title, desc }) => (
            <div className="va-benefit-card" key={title}>
              <Icon size={48} className="va-benefit-icon" />
              <h3>{title}</h3>
              <p>{desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="va-cta">
        <h2 className="va-cta-title">Ready to plan your next journey?</h2>
        <p className="va-cta-sub">
          Connect with India&apos;s most trusted travel experts. Get your trip
          planned in less than 2 minutes.
        </p>
        <button
          type="button"
          className="va-cta-btn"
          onClick={() => navigate('/contact-us')}
        >
          CONTACT US NOW
        </button>
        <p className="va-cta-note">
          No hidden charges. 100% Trusted &amp; Transparent Service.
        </p>
      </section>

      <footer className="va-brand-footer">
        <h2 className="va-brand-title">We are {appConfig.companyName}</h2>
        <p className="va-brand-tagline">
          Your Trusted Travel Partner — Reliable. Experienced. Customer-First.
        </p>
        <p className="va-brand-desc">
          {appConfig.companyName} is one of India&apos;s leading travel agencies
          providing complete end-to-end travel solutions for individuals,
          families, corporates and groups. We are a trusted partner for flights,
          hotels, holiday packages, visa assistance, travel insurance, cruises
          and passport services. We deliver personalized travel experiences with
          reliability, transparency and exceptional customer service — turning
          your travel dreams into beautiful realities.
        </p>
        <div className="va-social-links">
          <a
            href={appConfig.linkedinUrl || '#'}
            className="va-social-link va-social-linkedin"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>
          <a
            href={appConfig.whatsappUrl || '#'}
            className="va-social-link va-social-whatsapp"
            target="_blank"
            rel="noreferrer"
            aria-label="WhatsApp"
          >
            <FaWhatsapp />
          </a>
          <a
            href={appConfig.instagramUrl || '#'}
            className="va-social-link va-social-instagram"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>
          <a
            href={appConfig.facebookUrl || '#'}
            className="va-social-link va-social-facebook"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
          >
            <FaFacebook />
          </a>
        </div>
        <p className="va-brand-copy">
          © {new Date().getFullYear()} {appConfig.companyName}. All Rights
          Reserved.
        </p>
      </footer>
    </div>
  );
}

export default LoginPageVaya;
